import React from "react";
import Breadcrumb from "../../../Components/Common/Breadcrumb";
import { chapterTabsData } from "../../../data/SidebarData";
import Tabs from "../../../Components/Common/Tabs";
import StaticPageForm from "../../../Components/Common/Forms/StaticPageForm";

const QuizBankIndexMecha = () => {
  return (
    <div>
      <Breadcrumb actionButtons={[]} />
      <Tabs tabs={chapterTabsData} />
      <StaticPageForm
        title="Mechanical Quiz Bank"
        category="mechanical"
        subscription
        promo
        // typeData={data}
        // type="materials"
        // filter="subscription"
        // subscription
      />
    </div>
  );
};

export default QuizBankIndexMecha;
